import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    requestListFilters: {
        searchSTKTRFromDate: "",
        searchSTKTRToDate: "",
        searchSTKTRStatusIds: "",
        searchSTKTRReqNo: "",
        searchSTKTRCreatedByIds: "",
        searchSTKTRApprovedByIds: "",
        searchSTKTRRequestedFromStoreIds: "",
    },
    requestListData: {
        isLoading: false,
        dataLoaded: false,
        data: [],
        totalRecords: 0,
        pageNo: 0,
        perPageRecords: 25,
        transferRequestError: "",
        filteredData: [],
    },
    editRequestData: {
        isEditing: false,
        isLoading: false,
        isDataLoaded: true,
        requestData: null,
        selectedTransferRequestId:null,
        isLoadingFailed: false,
        failedMessage: null
    },
    showRequestListTable: false,
    loadtransferRequestList: false,
    showRequestForm:false,
    showTransferRequestPreview:false,
    transferRequestIdForPreview:null,
    transferRequestStatusForPreview:0,
    showTransferRequestStatusLogPreview:false,
    transferRequestRowForStatusLogPreview:null,
};

const inwardInventoryTransferSlice = createSlice({
    name: "inwardInventoryTransfer",
    initialState,
    reducers: {
        inwardInventoryTransferRequestListFiltersUpdates: (state, { payload }) => {
            if (payload?.searchSTKTRFromDate || 
                payload?.searchSTKTRToDate || 
                payload?.searchSTKTRStatusIds || 
                payload?.searchSTKTRReqNo || 
                payload?.searchSTKTRCreatedByIds ||
                payload?.searchSTKTRApprovedByIds ||
                payload?.searchSTKTRRequestedFromStoreIds
            ){
                state.requestListFilters = {...state.requestListFilters, ...payload}
            }
            state.showRequestListTable = false;
        },
        inwardInventoryTransferRequestListFiltersReset: (state) => {
            state.requestListFilters = {...initialState.requestListFilters};
        },
        inwardInventoryTransferRequestListLoadingPending: (state) => {
            state.requestListData.isLoading = true;
            state.requestListData.dataLoaded = false;
            state.showRequestListTable = false;
        },
        inwardInventoryTransferRequestListLoadingSuccess: (state, { payload }) => {
            state.requestListData.isLoading = false;
            state.requestListData.data = payload.data;
            state.requestListData.totalRecords = payload.totalRecords;
            state.requestListData.transferRequestError = "";
            state.requestListData.dataLoaded = true;
            state.loadtransferRequestList = false;
            state.showRequestListTable = true;
        },
        inwardInventoryTransferRequestListLoadingFailed: (state, { payload }) => {
            state.requestListData.isLoading = false;
            state.requestListData.data = [];
            state.requestListData.totalRecords =
            state.requestListData.transferRequestError = payload;
            state.requestListData.dataLoaded = true;
            state.loadtransferRequestList = false;
            state.showRequestListTable = false;
        },
        inwardInventoryTransferRequestListPageNoUpdate: (state, { payload }) => {
            state.requestListData.pageNo = payload;
            state.loadtransferRequestList = true;
        },
        inwardInventoryTransferRequestListPerPageRecordsUpdate: (state, { payload }) => {
            state.requestListData.perPageRecords = payload;
            state.requestListData.pageNo = 0;
            state.loadtransferRequestList = true;
        },
        toggleInwardInventoryRequestForm: (state, {payload}) => {
            state.showRequestForm = payload;
        },

        // Edit Transfer Request Reducers
        inwardInventoryTransferRequestSetFormEdit: (state,{payload}) => {
            state.editRequestData.isEditing = true;
            state.editRequestData.selectedTransferRequestId = payload;
        },
        inwardInventoryTransferRequestFormDataLoadingPending: (state) => {
            state.editRequestData.isLoading = true;
            state.editRequestData.isDataLoaded = false;
        },
        inwardInventoryTransferRequestFormDataLoadingSuccess: (state, { payload }) => {
            state.editRequestData.isLoading = false;
            state.editRequestData.requestData = payload;
            state.editRequestData.failedMessage = "";
            state.editRequestData.isDataLoaded = true;
            state.editRequestData.isLoadingFailed = false;
        },
        inwardInventoryTransferRequestFormDataLoadingFailed: (state, { payload }) => {
            state.editRequestData.isLoading = false;
            state.editRequestData.requestData = null;
            state.editRequestData.failedMessage = payload;
            state.editRequestData.isDataLoaded = true;
            state.editRequestData.isLoadingFailed = true;
        },
        inwardInventoryTransferRequestFormDataReset: (state, { payload }) => {
            state.editRequestData.isEditing = false;
            state.editRequestData.isLoading = false;
            state.editRequestData.requestData = null;
            state.editRequestData.failedMessage = null;
            state.editRequestData.isDataLoaded = false;
            state.editRequestData.isLoadingFailed = false;
            state.editRequestData.selectedTransferRequestId = null;
        },
        inwardInventoryTransferRequestPreviewShow: (state,{payload}) => {
            state.transferRequestIdForPreview = payload.transferRequestId;
            state.transferRequestStatusForPreview = payload.requestStatus
        },
        toggleInwardInventoryRequestPreview: (state, {payload}) => {
            state.showTransferRequestPreview = payload;
        },
        toggleInwardInventoryRequestStatusLogPreview: (state, {payload}) => {
            state.showTransferRequestStatusLogPreview = payload;
        },
        inwardInventoryTransferRequestStatusLogPreviewShow: (state,{payload}) => {
            state.transferRequestRowForStatusLogPreview = payload;
        },
    }
});


const { reducer, actions } = inwardInventoryTransferSlice;

export const {
    inwardInventoryTransferRequestListFiltersUpdates,
    inwardInventoryTransferRequestListFiltersReset,
    inwardInventoryTransferRequestListLoadingPending,
    inwardInventoryTransferRequestListLoadingSuccess,
    inwardInventoryTransferRequestListLoadingFailed,
    inwardInventoryTransferRequestListPageNoUpdate,
    inwardInventoryTransferRequestListPerPageRecordsUpdate,
    toggleInwardInventoryRequestForm,
    inwardInventoryTransferRequestSetFormEdit,
    inwardInventoryTransferRequestFormDataLoadingPending,
    inwardInventoryTransferRequestFormDataLoadingSuccess,
    inwardInventoryTransferRequestFormDataLoadingFailed,
    inwardInventoryTransferRequestFormDataReset,
    inwardInventoryTransferRequestPreviewShow,
    toggleInwardInventoryRequestPreview,
    toggleInwardInventoryRequestStatusLogPreview,
    inwardInventoryTransferRequestStatusLogPreviewShow
} = actions;

export default reducer;